import { IBaseCoords, IGroupSwimlane, IGroupSwimlaneConfig } from "@dhx/ts-diagram";
import { el, sv, VNode } from "@dhx/ts-common/dom";
import { BaseGroup } from "./BaseGroup";

export class GroupSwimlane extends BaseGroup implements IGroupSwimlane {
	config: IGroupSwimlaneConfig;

	constructor(config: IGroupSwimlaneConfig, params) {
		super(config, params);

		this.setServiceProp(config);
	}
	protected setServiceProp(config: IGroupSwimlaneConfig): void {
		const { height, width, $borderPosition } = config;

		config.$captureArea = config.$captureArea || "out";

		config.$borderPosition = {
			left: false,
			top: false,
			...$borderPosition,
		};

		config.entryArea.catchArea = 25;

		config.$width = width;
		config.$height = height;
	}
	protected setDefaults(config: IGroupSwimlaneConfig): IGroupSwimlaneConfig {
		super.setDefaults(config);

		delete config.header;
		return config;
	}
	public render(): VNode {
		this.setServiceProp(this.config);

		const { id, header, $width, $height } = this.config;

		let currentCss = "dhx_diagram_item dhx_diagram_group ";
		if (header?.enable) {
			currentCss += `dhx_diagram_group--position_${header.position} `;
		}

		function getGroupContainerStyle(
			config: IGroupSwimlaneConfig,
			coords: IBaseCoords
		): { [key: string]: string | number } {
			const { $width, $height, $captureArea, $borderPosition } = config;
			const { overFill, partiallyFill, fill, strokeWidth, stroke } = config.style;

			let background;
			switch ($captureArea) {
				case "over":
					background = overFill;
					break;
				case "partially":
					background = partiallyFill;
					break;
				default:
					background = fill;
					break;
			}

			const borderLeft = $borderPosition?.left ? strokeWidth : 0;
			const borderTop = $borderPosition?.top ? strokeWidth : 0;
			const boxShadow = `${borderLeft}px ${borderTop}px 0px ${stroke} inset`;

			return {
				position: "absolute",
				background,
				width: $width,
				height: $height,
				top: coords.y,
				left: coords.x,
				boxShadow,
			};
		}

		const htmlChildren = this.getChildHtmlNodes(this.config, this.data);
		const svgChildren = this.getChildSvgNodes(this.config, this.data);

		return el(
			"div.dhx_diagram_group_swimlane",
			{
				_key: id,
			},
			[
				el(
					"div",
					{
						dhx_id: id,
						class: `${currentCss} ${this.getCss()}`,
						style: getGroupContainerStyle(this.config, this.getCoords(this.config)),
					},
					[
						el("div.dhx_diagram_group__children", [
							sv(
								"svg.dhx_diagram_group__children",
								{
									xmlns: "http://www.w3.org/2000/svg",
									reserveAspectRatio: "none",
									width: $width,
									height: $height,
								},
								svgChildren
							),
							...htmlChildren,
						]),
					]
				),
			]
		);
	}
}
